/** Detected client platform. */
export type Platform = 'android' | 'ios' | 'desktop';

/** Detect the client platform from the browser user agent. */
export const getPlatform = (): Platform => {
    const { userAgent } = navigator;

    if (/android/i.test(userAgent)) {
        return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as { MSStream?: unknown }).MSStream) {
        return 'ios';
    }

    return 'desktop';
};

/**
 * Build a maps URL for an address — a native `geo:` link on Android, otherwise
 * a Google Maps web URL.
 */
export const getMapUrl = (address: string): string => {
    const platform = getPlatform();
    const encodedAddress = encodeURIComponent(address);

    if (platform === 'android') {
        return `geo:0,0?q=${encodedAddress}`;
    }
    return `https://maps.google.com?q=${encodedAddress}`;
};

/**
 * Build an `sms:` link that addresses a group of recipients. Comma-separated
 * recipients silently collapse to just the first number on both Android and
 * iOS, so each platform needs its own syntax: iOS only accepts a list via the
 * `/open?addresses=` form, Android requires semicolons after the scheme.
 */
export const getGroupSmsUrl = (numbers: string[]): string => {
    const recipients = numbers
        .map((number) => number.trim())
        .filter(Boolean);

    const platform = getPlatform();

    if (platform === 'ios') {
        return `sms:/open?addresses=${recipients.join(',')}`;
    }
    return `sms:${recipients.join(';')}`;
};
